import React from 'react';
import { useContext } from 'react';

import * as H from 'history';
import { TAppRouteProps } from 'src/routes/routes.config';


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type TAppLocationContextValue = H.Location<any> & { routeName: TAppRouteProps['routeName'] };

// @ts-ignore
const AppLocationContext = React.createContext<TAppLocationContextValue>(null);

export const AppLocationContextProvider = AppLocationContext.Provider;

export function useAppLocation(): TAppLocationContextValue {
  return useContext(AppLocationContext);
}
